import { render, staticRenderFns } from "./Dockets.vue?vue&type=template&id=6a1c44f2"
import script from "./Dockets.vue?vue&type=script&lang=js"
export * from "./Dockets.vue?vue&type=script&lang=js"
import style0 from "./Dockets.vue?vue&type=style&index=0&id=6a1c44f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports